/* unplugin-vue-components disabled */import { render } from "./NavLogoutIcon.vue?vue&type=template&id=bd59a1c0&scoped=true"
const script = {}

import "./NavLogoutIcon.vue?vue&type=style&index=0&id=bd59a1c0&scoped=true&lang=scss"

import exportComponent from "../../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd59a1c0"]])

export default __exports__